(function (w) {
    var Countdown = function (id, endTime) {
        this.id = id;
        this.endTime = new Date(endTime.replace(/-/g, '/'));
    };

    Countdown.instances = {};
    Countdown.getInstance = function (id, endTime) {
        if (this.instances[id]) {
            return this.instances[id];
        } else {
            this.instances[id] = new this(id, endTime);

            return this.instances[id];
        }
    };

    Countdown.prototype = {
        selectors: {
            days   : '.j-countdown-days',
            hours  : '.j-countdown-hours',
            minutes: '.j-countdown-minutes',
            seconds: '.j-countdown-seconds'
        },

        timer         : null,
        days          : null,
        hours         : null,
        minutes       : null,
        seconds       : null,
        timeIntervalId: null,

        init: function() {
            this.setContainers();
            this.initializeClock();
        },
        setContainers: function() {
            try {
                this.timer = document.querySelector('#' + this.id);

                this.days = this.timer.querySelector(this.selectors.days);
                this.hours = this.timer.querySelector(this.selectors.hours);
                this.minutes = this.timer.querySelector(this.selectors.minutes);
                this.seconds = this.timer.querySelector(this.selectors.seconds);

            } catch (e) {
                throw new Error(e.message)
            }

        },
        getTimeRemaining: function() {
            var t = this.endTime - (new Date()),
                seconds = Math.floor((t / 1000) % 60),
                minutes = Math.floor((t / 1000 / 60) % 60),
                hours = Math.floor((t / (1000 * 60 * 60)) % 24),
                days = Math.floor(t / (1000 * 60 * 60 * 24));

            return {
                'total'  : t,
                'days'   : days,
                'hours'  : hours,
                'minutes': minutes,
                'seconds': seconds
            };
        },
        initializeClock: function() {
            this.updateClock();

            this.timeIntervalId = setInterval(this.tick(), 500);
        },
        updateClock: function() {
            var t = this.getTimeRemaining(this.endTime);

            this.days.innerHTML = t.days;
            this.hours.innerHTML = ('0' + t.hours).slice(-2);
            this.minutes.innerHTML = ('0' + t.minutes).slice(-2);
            this.seconds.innerHTML = ('0' + t.seconds).slice(-2);

            if (t.total <= 0) {
                clearInterval(this.timeIntervalId);
                this.remove();
            }
        },
        tick: function() {
            var self = this;

            return function() {
                self.updateClock()
            };
        },
        remove: function() {
            this.timer.remove();
        }
    };

    w.Countdown = Countdown;
})(window);